<template>
  <div class="vokalis-chart-widget">
    <template v-if="!loading">
      <div class="widget__header widget__header--no-border">
        <div class="widget__header-main">
          <div class="widget__header-title-wrapper">
            <div class="widget__header-title">{{ widget.title }}</div>
          </div>
          <div v-if="widget.description" class="widget__header-description">
            {{ widget.description }}
          </div>
        </div>
        <WidgetContextMenu
          v-if="isEditMode"
          :widget="widget"
          :dashboard="dashboard"
          @delete-widget="$emit('delete-widget', $event)"
        />
      </div>
      <div class="widget__content">
        <VokalisChart
          v-if="dataForDataSource && dataSource"
          :data-source="dataSource"
          :data-source-data="dataForDataSource"
          :series-config="widget.series_config || []"
        />
        <div v-else class="vokalis-chart-widget__loading loading-spinner"></div>
      </div>
    </template>
    <div v-else class="vokalis-chart-widget__loading loading-spinner"></div>
  </div>
</template>

<script>
import VokalisChart from './Chart'
import WidgetContextMenu from '@baserow/modules/dashboard/components/widget/WidgetContextMenu'

export default {
  name: 'VokalisChartWidget',
  props: {
    dashboard: { type: Object, required: true },
    widget: { type: Object, required: true },
    storePrefix: { type: String, required: false, default: '' },
    loading: { type: Boolean, required: false, default: false },
    editMode: { type: Boolean, required: false, default: false },
  },
  components: { VokalisChart, WidgetContextMenu },
  computed: {
    dataSource() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/getDataSourceById`
      ](this.widget.data_source_id)
    },
    dataForDataSource() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/getDataForDataSource`
      ](this.dataSource?.id)
    },
    isEditMode() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/isEditMode`
      ]
    },
  },
}
</script>

<style scoped>
.vokalis-chart-widget {
  min-height: 140px;
}
</style>

